module.exports = __webpack_public_path__ + "static/media/startpage2026_1366.55395e39.jpg";